import { z } from 'zod';

export enum TaskStatus {
  OPEN = 'Open',
  IN_PROGRESS = 'In Progress',
  EXTERNAL_REVIEW = 'External Review',
  DONE = 'Done',
}

export const TaskStatusSchema = z.nativeEnum(TaskStatus);
